import Vue from "vue";
import stripeAccountsService from "./../../../services/stripe_accounts";
import checklistGroupTypeService from "./../../../services/checklist_group_type";
import checklistGroupService from "./../../../services/checklist_group";
import fileService from "./../../../services/file";
import formService from "./../../../services/form";
import mixin from "../../../mixins/mixin";
import rentalService from "./../../../services/rental";
import automationService from "../../../services/automation";
import accountService from "../../../services/account";
import platformService from "../../../services/platforms";
import VueTextareaAutosize from "vue-textarea-autosize";
import TimePicker from "vue2-timepicker";
import Services from "./services";
import moment from "moment";
import currencyService from "../../../services/currency";
import eventLogger from "../../../services/event-logger";
import updateRentalAirbnbData from "../../../services/rental/updateRentalAirbnbData";

export default {
  data() {
    return {
      types: {
        apartments: {
          display: "Apartments",
          value: [
            {
              id: "apartment",
              display: "Apartment",
            },
            {
              id: "condominium",
              display: "Condominium",
            },
            {
              id: "loft",
              display: "Loft",
            },
            {
              id: "serviced_apartment",
              display: "Serviced Apartment",
            },
          ],
        },
        houses: {
          display: "Houses",
          value: [
            {
              id: "house",
              display: "House",
            },
            {
              id: "cabin",
              display: "Cabin",
            },
            {
              id: "villa",
              display: "Villa",
            },
            {
              id: "townhouse",
              display: "Townhouse",
            },
            {
              id: "cottage",
              display: "Cottage",
            },
            {
              id: "bungalow",
              display: "Bungalow",
            },
            {
              id: "earthhouse",
              display: "Earthhouse",
            },
            {
              id: "houseboat",
              display: "Houseboat",
            },
            {
              id: "hut",
              display: "Hut",
            },
            {
              id: "farm_stay",
              display: "Farm Stay",
            },
            {
              id: "dome_house",
              display: "Dome House",
            },
            {
              id: "chalet",
              display: "Chalet",
            },
            {
              id: "lighthouse",
              display: "Lighthouse",
            },
            {
              id: "shepherds_hut",
              display: "Shepherds Hut",
            },
            {
              id: "tiny_house",
              display: "Tiny House",
            },
          ],
        },
        secondary_units: {
          display: "Secondary units",
          value: [
            {
              id: "guesthouse",
              display: "Guesthouse",
            },
            {
              id: "guest_suite",
              display: "Guest Suite",
            },
            {
              id: "farm_stay",
              display: "Farm Stay",
            },
          ],
        },
        unique_homes: {
          display: "Unique Homes",
          value: [
            {
              id: "barn",
              display: "Barn",
            },
            {
              id: "boat",
              display: "Boat",
            },
            {
              id: "bus",
              display: "Bus",
            },
            {
              id: "rv",
              display: "RV",
            },
            {
              id: "treehouse",
              display: "Treehouse",
            },
            {
              id: "campsite",
              display: "Campsite",
            },
            {
              id: "castle",
              display: "Castle",
            },
            {
              id: "cave",
              display: "Cave",
            },
            {
              id: "dome_house",
              display: "Dome House",
            },
            {
              id: "earthhouse",
              display: "Earthouse",
            },
            {
              id: "farm_stay",
              display: "Farm Stay",
            },
            {
              id: "holiday_park",
              display: "Holiday Park",
            },
            {
              id: "houseboat",
              display: "Houseboat",
            },
            {
              id: "hut",
              display: "Hut",
            },
            {
              id: "igloo",
              display: "Igloo",
            },
            {
              id: "island",
              display: "Island",
            },
            {
              id: "lighthouse",
              display: "Lighthouse",
            },
            {
              id: "plane",
              display: "Plane",
            },
            {
              id: "ranch",
              display: "Ranch",
            },
            {
              id: "religious_building",
              display: "Religious Building",
            },
            {
              id: "shepherds_hut",
              display: "Shepherds Hut",
            },
            {
              id: "shipping_container",
              display: "Shipping Container",
            },
            {
              id: "tent",
              display: "Tent",
            },
            {
              id: "tiny_house",
              display: "Tiny House",
            },
            {
              id: "tipi",
              display: "Tipi",
            },
            {
              id: "tower",
              display: "Tower",
            },
            {
              id: "train",
              display: "Train",
            },
            {
              id: "windmill",
              display: "Windmill",
            },
            {
              id: "yurt",
              display: "Yurt",
            },
            {
              id: "riad",
              display: "Riad",
            },
            {
              id: "other",
              display: "Other",
            },
          ],
        },
        bnb: {
          display: "BNB",
          value: [
            {
              id: "bnb",
              display: "BNB",
            },
            {
              id: "lodge",
              display: "Lodge",
            },
            {
              id: "farm_stay",
              display: "Farm Stay",
            },
          ],
        },
        boutique_hotels_and_more: {
          display: "Others",
          value: [
            {
              id: "hotel",
              display: "Hotel",
            },
            {
              id: "hostel",
              display: "Hostel",
            },
            {
              id: "resort",
              display: "Resort",
            },
            {
              id: "lodge",
              display: "Lodge",
            },
            {
              id: "boutique_hotel",
              display: "Boutique Hotel",
            },
            {
              id: "aparthotel",
              display: "Aparthotel",
            },
            {
              id: "serviced_apartment",
              display: "Serviced Apartment",
            },
          ],
        },
      },
      rental: {
        airbnbConnected: false,
        image: "",
        country_id: 1,
        address: "",
        capacity: 3,
        default_persone_count: 2,
        bathroom_count: 1,
        bedroom_count: 1,
        checkin: "15:00",
        checkout: "11:00",
        checkin_end: "23:45",
        cut_off_hour: null,
        min_days_until_checkin: null,
        city: "",
        cleaning: 0,
        price: 0,
        deposit: 0,
        name: "",
        price_extra: 0,
        city_taxes_type: "per_person",
        city_taxes: 0,
        vat: 0,
        concierge_commission: 20,
        concierge_cleaning_fees: 0,
        concierge_checkin_fees: 10,
        checkin_duration: 30,
        checkout_duration: 120,
        taxes_limit: "",
        taxes_percent: "",
        status: "1",
        zip_code: "",
        photos: [],
        channels: [],
        contract: "",
        invoice_template: "",
        booking_url: "",
        expedia_url: "",
        google_url: "",
        airbnb_url: "",
        netatmo_device_id: "",
        netatmo_module_id: "",
        permalink: "",
        theKeys: {},
        booking_email: null,
        forward_email: null,
        superCheckinLocks: {},
        igloohomeLock: {},
        send_automatic_payment_link: 0,
        send_automatic_deposit_link: 0,
        min_advanced_booking_offset: 1,
        max_advanced_booking_offset: 30,
        min_stay_arrival: 1,
        max_stay_arrival: 30,
        gap_fill: 0,
        gap_fill_percent: 0,
        default_inventory: 1,
        sync_in_progress: 0,
        dynamic_price_enabled: false,
        airbnbConnectedDate: null,
        bookingConnectedDate: null,
        dynamic_price_settings: null,
        currency_id: 28,
        property_type_group: "apartments",
        property_type: "apartment",
        airbnb_max_nights: 1,
        airbnb_min_nights: 1,
        airbnb_availability_range: 30,
        airbnb_preparation_time: 1,
        instant_booking_allowed_category: "",
      },
      webSiteDefaultContent: {},
      originalRentalData: false,
      isGoingBack: false,
      user: {
        currency: {},
      },
      membersForChecking: [],
      membersForCheckout: [],
      rentalEdit: false,
      checkedChannels: [],
      channels: {},
      templates: {},
      netatmoDevices: {},
      netatmoModules: [],
      image: {},
      invoice_logo: {},
      countries: {},
      error: null,
      success: false,
      loading: true,
      loadingImage: false,
      activeTab: "",
      contract: "",
      theSpace: {
        name: "",
        file: "",
        images: [],
      },
      customTemplate: {},
      invoice: [],
      promise1: {},
      promise2: {},
      promise3: {},
      promise4: {},
      stripeClientId: process.env.STRIPE_CLIENT_ID,
      stripe_accounts: [],
      stripe_name: "",
      checklistGroups: [],
      newChecklistGroup: {
        title: "",
        description: "",
        checklist_group_type_id: 4,
        checklists: [],
        images: [],
      },
      checlistGroupTypes: {},
      checlistItem: "",
      checklists: [],
      checklistGroupImages: [],
      selectedChecklistId: "",
      forms: [],
      formItem: {
        title: "",
        description: "",
        redirect_url: "",
        redirect_file: "",
        type: "",
      },
      formItemIsEmpty: false,
      formCheckType: {
        type: "",
        rental_id: "",
      },
      selectedFormId: "",
      formImage: {},
      formImageUploaded: false,
      formsFields: {
        id: "",
        element_id: "",
        element: [],
        label: "",
        type: "",
        mandatory: "",
        reference: "",
        select_options: [],
      },
      formsFieldsTypes: [],
      formsFieldsReferences: [],
      formsFieldsInputTypes: [],
      formTypes: [],
      formItems: [],
      newFormSelect: [],
      typeIsInput: false,
      typeIsSelect: false,
      typeIsTextarea: false,
      newFormSelectIsSelect: [],
      select_options: [],
      selectOptionName: "",
      loadingInModal: false,
      imageUploadLoading: false,
      formIsCreated: false,
      editFormModal: false,
      form: "",
      icsLink: "",
      theKeys: [],
      selected_lock: {},
      lock_types: [],
      airbnb: [],
      airbnbAccounts: [],
      airbnbListingsLoading: false,
      airbnbRentals: [],
      selectedChecklistItemIndex: null,
      airbnbAttachedRentalIds: [],
      rentalEvents: [],
      selectedBookingEvent: {
        checklist_group_type: {},
      },
      api_url: "",
      fieldIsEditing: false,
      expediaButtonDisabled: false,
      invoiceLogoIsDeleting: false,
      rentalImageIsDeleting: false,
      superCheckinLocks: [],
      accountLockTypes: [],
      isSuperCheckinSelected: false,
      isTheKeysSelected: false,
      lockType: "",
      superCheckinAccount: [],
      shortCodes: [],
      rentals: {},
      smallLoading: false,
      loadingFile: false,
      fileUploaded: false,
      uploadedFilepath: "",
      platforms: [],
      selectedPlatforms: [],
      selectedDepositPlatforms: [],
      rentalAvatar: [],
      invoiceLogo: [],
      igloohomeLocks: [],
      igloohomeV2Locks: [],
      nukiLocks: [],
      isIgloohomeSelected: false,
      isIgloohomeV2Selected: false,
      isNukiLockSelected: false,
      isSmsSubscriptionActive: true,
      rateCodes: [],
      roomCodes: [],
      name: "",
      link: "",
      icalRestrictionId: "",
      icalOverride: false,
      icals: "",
      showSaveButton: false,
      selectedIcalId: false,
      minutes: ["00"],
      checkinMinutes: ["00", "15", "30", "45"],
      cutOffHours: [],
      checkinHours: [],
      availability_ranges: [
        {
          value: 0,
          text: "Date indisponible par defaut",
        },
        {
          value: 30,
          text: "1 mois",
        },
        {
          value: 90,
          text: "3 mois",
        },
        {
          value: 180,
          text: "6 mois",
        },
        {
          value: 270,
          text: "9 mois",
        },
        {
          value: 365,
          text: "12 mois",
        },
        {
          value: -1,
          text: "24 mois",
        },
      ],
      airbnb_preparation_times: [
        {
          value: 0,
          text: "Aucun",
        },
        {
          value: 1,
          text: "1 nuit avant et après chaque réservation",
        },
        {
          value: 2,
          text: "2 nuits avant et après chaque réservation",
        },
      ],
      instant_booking_allowed_categories: [
        {
          value: "off",
          text: "Off",
        },
        {
          value: "everyone",
          text: "Everyone",
        },
        {
          value: "well_reviewed_guests",
          text: "Well reviewed Guests",
        },
        {
          value: "guests_with_verified_identity",
          text: "Guests with verified Identity",
        },
        {
          value: "well_reviewed_guests_with_verified_identity",
          text: "Well reviewed Guests With verified Identity",
        },
      ],
      checkinCheckoutDurationMinutes: [],
      serviceData: {
        rentalId: "",
        selectedLockType: "",
        selectedNetatmoDevice: "",
        the_keys_locks: [],
        igloohomeLocks: [],
        igloohomeV2Locks: [],
        nukiLocks: [],
        superCheckinLocks: [],
        price_lab_enabled: 0,
        price_lab_email: "",
        price_lab_api_key: "",
      },
      rentalBookingComConfigs: {
        hotelId: Number,
        roomCode: Number,
        rateCode: Number,
      },
      minMaxConfigsLoading: false,
      priceMultiplier: [],
      icalRestrictions: [],
      steps: [],
      formSteps: {},
      icalLinkClipboard: "",
      clipboardBtnCopyFormLink: "",
      currencies: [],
      vrbo: {
        advertiser_id: "",
        listing_id: "",
        vrbo_account_active: false,
      },
      vrboAmenities: [],
      airbnbKeyId: null,
      logs: [],
    };
  },

  components: {
    VLayout: require("layouts/default/default.vue"),
    VPanel: require("components/panel/panel.vue"),
    Redactor: require("components/redactor/redactor.vue"),
    VLoading: require("components/loading/loading.vue"),
    VPlatforms: require("./platform"),
    VBillingModal: require("layouts/default/billing-modal"),
    VDepositAutoConfirmedPlatforms: require("./depositAutoConfirmedPlatforms"),
    VImportBookingsFromFile: require("./modals/ImportBookingsFromFile"),
    VVrboConfigurationModal: require("./modals/VrboConfigurationModal"),
    VueTimepicker: TimePicker,
    VServices: Services,
    VSpecialFeatures: require("./SpecialFeatures"),
    VVrboConfigurationTab: require("./VrboConfigurationTab/VrboConfigurationTab.vue"),
    VWebsite: require("./website"),
    VSyncInProgressModal: require("components/sync-in-progress-modal/modal.vue"),
  },

  mixins: [mixin],

  async mounted() {
    const vm = this;

    vm.api_url = process.env.API_URL;
    Vue.use(VueTextareaAutosize);

    $("#form-input-file-now").dropify({
      messages: {
        default: vm.$t("drag_and_drop_file"),
        replace: "Drag and drop or click to replace",
        remove: "Remove",
        error: "Ooops, something wrong happened.",
      },
    });

    $("#invoice-logo-container").dropify({
      messages: {
        default: vm.$t("drag_and_drop_file"),
        replace: "Drag and drop or click to replace",
        remove: "Remove",
        error: "Ooops, something wrong happened.",
      },
    });

    $("#input-file-now").dropify({
      messages: {
        default: vm.$t("drag_and_drop_file"),
        replace: "Drag and drop or click to replace",
        remove: "Remove",
        error: "Ooops, something wrong happened.",
      },
    });
    vm.getChannels();
    vm.getCountries();
    currencyService.getCurrencies(this);
    vm.getTemplates();
    vm.getNetatmoDevices();
    vm.getStripeAccounts();
    await vm.getFormTypes();
    await vm.getFormFieldTypes();
    await vm.getFormFieldReferences();
    await vm.getAirbnbListings();
    await vm.getAccountLockTypes();
    await vm.getIcalRestrictions();
    await automationService.getCustomShortCodes(vm);
    await platformService.getPlatforms(this);
    let tab = "rental-info";

    if (vm.$route.params.id) {
      const rentalId = vm.$route.params.id;
      await vm.getRentalEvents(rentalId);
      rentalService.getIcals(vm, { rentalId });
      await vm.fetchRental(rentalId);
      await vm.getChecklistGroup(rentalId);
      await vm.getAllForms(rentalId);

      if (vm.$route.params.tab) {
        tab = vm.$route.params.tab;
      }
      this.addClipboard(".ical-link", "icalLinkClipboard", this);
    }
    if (typeof window.Site !== "undefined") {
      window.Site.getInstance().initializePlugins();
    }

    if ($.fn.jquery !== "2.2.4") {
      $.noConflict();
    }

    $("i[data-toggle='popover']").on("click", (e) => {
      $(e.target).popover("toggle");
    });

    $(
      ".rental-detail-popover, #rental-detail, .site-menubar-body, .site-navbar, .page-content"
    ).on("click", (e) => {
      if ($(e.target).data("toggle") !== "popover") {
        $('[data-toggle="popover"]').popover("hide");
      }
    });

    this.initRentalCutOffHours();
    this.initRentalCutOffMinutes();
    await vm.change_tab(tab);
    await rentalService.get(vm);

    if (vm.rental && vm.rental.airbnb_account_id) {
      vm.airbnbKeyId = `${vm.rental.airbnb_account_id}-${vm.rental.airbnb_rental_id}`;
    }
    this.loading = false;
  },

  updated() {
    $("i[data-toggle='popover']")
      .off("click")
      .on("click", (e) => {
        $(e.target).popover("toggle");
      });
  },

  watch: {
    isGoingBack(isTrue) {
      if (isTrue) {
        this.rental = this.originalRentalData;
        this.originalRentalData = false;
        this.isGoingBack = !isTrue;
      }
    },
    "$route.params.tab": function (newTab, oldTab) {
      if (newTab) {
        this.change_tab(newTab);
      }
    },

    rental(newTab, oldTab) {
      if (newTab) {
        this.getNetatmoDevices();
        this.rental.airbnbConnectedDate = newTab.airbnb_account_connected_date
          ? moment(newTab.airbnb_account_connected_date).format(
              "ddd DD MMMM YYYY HH:mm:ss"
            )
          : null;
        this.rental.bookingConnectedDate = newTab.booking_account_connected_date
          ? moment(newTab.booking_account_connected_date).format(
              "ddd DD MMMM YYYY HH:mm:ss"
            )
          : null;
      }
    },

    airbnbKeyId(newKey, oldKey) {
      console.log(newKey, oldKey);
      if (oldKey !== newKey && oldKey !== null) {
        this.rental.new_rental = true;
      } else {
        this.rental.new_rental = false;
      }
      console.log("trnr:", this.rental.new_rental);
      if (!newKey) {
        this.rental.airbnb_rental_id = null;
        this.rental.airbnb_account_id = null;
      } else {
        const key = newKey.split("-");
        this.rental.airbnb_rental_id = key[1];
        this.rental.airbnb_account_id = key[0];
      }
    },
    "rental.sms_integration": function () {
      if (
        this.rental.sms_integration === true &&
        this.user &&
        !this.isSmsSubscriptionActive
      ) {
        this.openModal("#add-card-modal");
        mixpanel.track("web.rentals.enable.sms");
      }
    },

    "rental.payment_integration": function (
      isPaymentIntegrationChecked,
      wasPaymentIntegrationChecked
    ) {
      if (!isPaymentIntegrationChecked) {
        this.rental.send_automatic_payment_link = 0;
      }
    },

    "rental.deposit_integration": function (
      isDepositIntegrationChecked,
      wasDepositIntegrationChecked
    ) {
      if (!isDepositIntegrationChecked) {
        this.rental.send_automatic_deposit_link = 0;
      }
    },

    theKeys(newKey, oldKey) {
      if (oldKey.length === 0 && newKey.length) {
        this.generateTheKeysData();
      }
    },
    "rental.lock_type": function (newKey, oldKey) {
      if (newKey !== oldKey) {
        this.serviceData.selectedLockType = this.rental.lock_type;
      }
    },
    "rental.price_lab_enabled": function (newKey, oldKey) {
      if (newKey !== oldKey) {
        this.serviceData.price_lab_enabled = this.rental.price_lab_enabled;
      }
    },
    igloohomeLocks() {
      this.serviceData.igloohomeLocks = this.igloohomeLocks.filter(
        (lock) => lock.connected
      );
    },

    igloohomeV2Locks() {
      this.serviceData.igloohomeV2Locks = this.igloohomeV2Locks.filter(
        (lock) => lock.connected
      );
    },
    superCheckinLocks() {
      this.serviceData.superCheckinLocks = this.superCheckinLocks.filter(
        (lock) => lock.connected
      );
    },
    nukiLocks() {
      this.serviceData.nukiLocks = this.nukiLocks.filter(
        (lock) => lock.connected
      );
    },
  },

  methods: {
    updateTypeList() {
      console.log(this.rental);
    },
    goBack() {
      this.isGoingBack = true;
      window.history.back();
    },
    getChannels() {
      // TODO Create Service for getting channels
      this.promise1 = Vue.$http
        .get("/channels")
        .then((response) => {
          this.channels = response.data.channels;
        })
        .catch((error) => {});
    },
    getCountries() {
      // TODO Create Service for getting Countries
      this.promise2 = Vue.$http
        .get("/countries")
        .then((response) => {
          this.countries = response.data.countries;
        })
        .catch((error) => {});
    },
    getTemplates() {
      // TODO Create Service for getting Templates
      this.promise3 = Vue.$http
        .get("/templates")
        .then((response) => {
          this.templates = response.data.templates;
        })
        .catch((error) => {});
    },
    getNetatmoDevices() {
      // TODO Create Service for getting Netatmo Devices
      this.promise4 = Vue.$http
        .get("/netatmo-devices")
        .then((response) => {
          this.netatmoDevices = response.data.netatmoDevices;
          this.getModuleOfDevice();
        })
        .catch((error) => {});
    },
    delete_rental(id) {
      swal(
        {
          title: this.$t("rentals.detail.modals.are_you_sure"),
          text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>${this.$t(
            "rentals.detail.modals.can_not_recover_rental"
          )}</div>`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: "Yes, delete it!",
          closeOnConfirm: false,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();

          rentalService.destroy(this, id);
        }
      );
    },
    async save_rental(rental) {
      this.loading = true;
      let img = "";

      if ($("#user-data .dropify-errors-container ul")[0].innerText === "") {
        img = this.rentalAvatar[0];
      }

      const formData = new FormData();
      formData.append("image", img);
      formData.append("folder", "rentals");
      if (this.rental.price_extra) {
        this.rental.price_extra = Math.round(this.rental.price_extra);
      }
      if (img && img.name) {
        await rentalService.storeFiles(this, formData);
        rental.image && this.store_rental(rental);
      } else {
        rental.image = null;
        this.store_rental(rental);
      }
    },
    duplicateRental() {
      this.originalRentalData = { ...this.rental };
      const newRental = {
        id: null,
        name: this.rental.name,
        owner_first_name: this.rental.owner_first_name,
        owner_last_name: this.rental.owner_last_name,
        owner_address: this.rental.owner_address,
        owner_post_code: this.rental.owner_post_code,
        owner_city: this.rental.owner_city,
        capacity: this.rental.capacity,
        default_persone_count: this.rental.default_persone_count,
        price: this.rental.price,
        price_extra: this.rental.price_extra,
        cleaning: this.rental.cleaning,
        taxes_limit: this.rental.taxes_limit,
        taxes_percent: this.rental.taxes_percent,
        city_taxes: this.rental.city_taxes,
        city_taxes_type: this.rental.city_taxes_type,
        deposit: this.rental.deposit,
        vat: this.rental.vat,
        checkin: this.rental.checkin,
        checkout: this.rental.checkout,
        checkin_end: this.rental.checkin_end,
        checkin_duration: this.rental.checkin_duration,
        checkout_duration: this.rental.checkout_duration,
        cut_off_hour: this.rental.cut_off_hour,
        status: this.rental.status,
        refund_days: this.rental.refund_days,
        address: this.rental.address,
        zip_code: this.rental.zip_code,
        city: this.rental.city,
        country_id: this.rental.country_id,
        email: this.rental.email,
        sms_integration: false,
        payment_integration: false,
        deposit_integration: false,
        auto_refund: false,
        auto_cancellation: false,
        send_automatic_payment_link: false,
        send_automatic_deposit_link: false,
        default_inventory: this.rental.default_inventory,
        property_type_group: this.rental.property_type_group,
        property_type: this.rental.property_type,
      };

      this.rental = { ...newRental };
      Vue.router.push({
        name: "rentals.create",
      });
    },
    store_rental(rental) {
      rentalService.storeRental(this, rental);
      mixpanel.track("web.rentals.create");
    },
    edit_rental(rental, toPage) {
      const vm = this;
      vm.editRental = true;

      if ($("#user-data .dropify-errors-container ul")[0].innerText === "") {
        this.image = vm.rentalAvatar[0];
      }
      if (
        $(".images-rentals .dropify-errors-container ul")[0].innerText === ""
      ) {
        this.invoice_image = vm.invoiceLogo[0];
      }

      const img = vm.image;
      const image = { image: img };

      const invoice_img = vm.invoice_image;
      const invoice_image = { invoice_logo: invoice_img };

      const formData = new FormData();
      formData.append("image", img);
      formData.append("folder", "rentals");

      const invoiceFormData = new FormData();
      invoiceFormData.append("image", invoice_img);
      invoiceFormData.append("folder", "invoice-logo");
      if (this.rental.price_extra) {
        this.rental.price_extra = Math.round(this.rental.price_extra);
      }
      if (img && img.name) {
        // TODO Use Service for files request
        Vue.$http
          .post("/files", formData)
          .then((response) => {
            if (response && response.status === 200) {
              rental.image = response.data.image;
              if (invoice_img && invoice_img.name) {
                // TODO Use service for files request
                Vue.$http
                  .post("/files/upload-invoice-image", invoiceFormData)
                  .then((response) => {
                    if (response && response.status === 200) {
                      rental.invoice_logo = response.data.image;
                      vm.update_rental(rental, toPage);
                    }
                  })
                  .catch((error) => {
                    if (error.response) {
                      $("#rental-invoice-logo .dropify-clear").click();
                      toastr.error(error.response.data.msg.image[0]);
                    }
                  });
              } else {
                vm.update_rental(rental, toPage);
              }
            } else {
              toastr.error(error.response.data.message);
            }
          })
          .catch((error) => {
            toastr.error(error.toString());
            toastr.error(error.response.data.message);
          });
      } else {
        if (invoice_img && invoice_img.name) {
          // TODO Use Service for files request
          Vue.$http
            .post("/files/upload-invoice-image", invoiceFormData)
            .then((response) => {
              if (response && response.status === 200) {
                rental.invoice_logo = response.data.image;
                vm.update_rental(rental, toPage);
              }
            })
            .catch((error) => {
              if (error.response) {
                $("#rental-invoice-logo .dropify-clear").click();
                toastr.error(error.response.data.msg.image[0]);
              }
            });
        } else {
          vm.update_rental(rental, toPage);
        }
        $(".dropify-preview").css("display", "none");
      }
    },
    onFileChange(e) {
      const vm = this;
      vm.rentalAvatar = e.target.files || e.dataTransfer.files;
      if (!vm.rentalAvatar.length) {
      }
    },
    onLogoChange(e) {
      const vm = this;
      vm.invoiceLogo = e.target.files || e.dataTransfer.files;
      if (!vm.invoiceLogo.length) {
      }
    },
    async deleteInvoiceLogo() {
      const vm = this;
      vm.invoiceLogoIsDeleting = true;
      await rentalService.deleteInvoiceLogo(vm, vm.rental.id);
    },
    deleteRentalLogo() {
      this.rentalImageIsDeleting = true;
      rentalService.deleteRentalImage(this, this.rental.id);
    },

    async fetchRental(id) {
      const vm = this;
      await rentalService.getById(id, vm);
      if (vm.rental.airbnb_account_id) {
        vm.rental.airbnbConnected = true;
      }
    },

    updateSelectedPlatforms(platformId) {
      if (platformId) {
        if (this.selectedPlatforms.includes(platformId.toString())) {
          this.selectedPlatforms = this.selectedPlatforms.filter(
            (platform) => platform.toString() !== platformId.toString()
          );
        } else {
          this.selectedPlatforms.push(platformId.toString());
        }
      }
    },
    async update_rental(rental, toPage) {
      const vm = this;
      for (let i = 0; i < rental.the_keys_locks.length; i++) {
        if (rental.the_keys_locks[i] && rental.the_keys_locks[i].type == null) {
          toastr.error(vm.$t("rentals.detail.the_keys.validate_type"));
          return;
        }
      }
      vm.loading = true;
      rental.contract = $("#redactor-uuid-1").html();
      rental.theKeys = vm.theKeys;
      const listing = vm.airbnbRentals.find(
        (el) => el.id === rental.airbnb_rental_id
      );
      if (listing) {
        rental.airbnb_account_id = listing.airbnb_account_id;
      }
      rental.auto_confirm_platform_id = JSON.stringify(vm.selectedPlatforms);
      rental.deposit_auto_confirm_platform_ids = JSON.stringify(
        vm.selectedDepositPlatforms
      );

      const dependencies = [...rental.dependencies];
      rental.dependencies = [];
      dependencies.map((value) => {
        if (value.dep_rental_id) {
          rental.dependencies = [...rental.dependencies, value.dep_rental_id];
        } else {
          rental.dependencies = [...rental.dependencies, value];
        }
      });
      await rentalService.updateRental(vm, rental, toPage);
    },
    updateRentalServices() {
      this.loading = true;
      if (this.serviceData.selectedLockType === "TheKeys") {
        for (let i = 0; i < this.serviceData.the_keys_locks.length; i++) {
          if (
            this.serviceData.the_keys_locks[i].connected &&
            this.serviceData.the_keys_locks[i].type == null
          ) {
            toastr.error(this.$t("rentals.detail.the_keys.validate_type"));
            this.loading = false;
            return;
          }

          if (
            this.serviceData.the_keys_locks[i].connected &&
            this.serviceData.the_keys_locks[i].accessory_code == null
          ) {
            toastr.error(
              this.$t("rentals.detail.the_keys.validate_accessory_id")
            );
            this.loading = false;
            return;
          }
        }
      }
      this.serviceData.selectedNetatmoDevice = this.rental.netatmo_device_id;
      this.serviceData.rentalId = this.rental.id;
      rentalService.updateRentalServices(this, this.serviceData);
    },
    async addOrChangeTeamMember(rentalId, memberId, type) {
      const data = {
        rentalId,
        memberId,
        type,
      };
      await rentalService.assignTeamMemberToRental(this, data, type);
    },
    async change_tab(tab) {
      const vm = this;
      const tabs = [
        "rental-info",
        "templates",
        "invoice",
        "channels",
        "checklists",
        "forms",
        "parameters",
        "platforms",
        "services",
        "web-site",
        "vrbo-configuration-tab",
        "event-logger",
      ];
      if (tabs.includes(tab)) {
        vm.activeTab = tab;
      }
      switch (tab) {
        case "invoice":
          vm.fetchRental(vm.$route.params.id);
          break;
        case "event-logger":
          await eventLogger.get(vm, vm.$route.params.id);
          break;
      }
      if (vm.$route.params.id) {
        Vue.router.push({
          name: "rentals.detail.tab",
          params: {
            id: vm.$route.params.id,
            tab: vm.activeTab,
          },
        });
      }
    },
    changeContract(template) {
      $("#redactor-uuid-1").html(template.content);
    },
    save_custom_template(rental) {
      const vm = this;
      vm.customTemplate.content = $("#redactor-uuid-1").html();
      vm.customTemplate.thumbnail = null;
      vm.customTemplate.rental_id = rental.id;
      vm.customTemplate.type = "contract";
      // TODO create servrce for save custom template
      Vue.$http
        .post("/templates", vm.customTemplate)
        .then((response) => {
          if (response && response.status === 200) {
            vm.customTemplate = {};
            $("#modal-close").click();
            vm.getTemplates();
            $("#redact").html("");
            toastr.success(response.data.msg);
          }
        })
        .catch((error) => {
          vm.showToasterError(error);
        });
    },
    delete_template(id) {
      const vm = this;
      swal(
        {
          title: "Are you sure?",
          text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>You will not be able to recover this template</div>',
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: "Yes, delete it!",
          closeOnConfirm: false,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();
          // TODO Use service for deleting template
          Vue.$http
            .delete(`/templates/${id}`)
            .then((response) => {
              if (response && response.status === 200) {
                $(".cancel").removeClass("disabled");
                $(".confirm").removeClass("disabled");
                vm.getTemplates();
                toastr.success(response.data.msg);
                swal("Deleted!", "Template has been deleted!", "success");
                vm.loading = false;
                $("#redact").html("");
              }
            })
            .catch((error) => {
              if (error.response) {
                $(".cancel").removeClass("disabled");
                $(".confirm").removeClass("disabled");
              }
            });
        }
      );
    },
    edit_template(template) {
      const vm = this;
      vm.customTemplate = template;
      $("#redact").html("");
      const test = $("#redactor-uuid-1").clone();
      test.html(template.content);

      $("#redact").html(test);
    },
    update_custom_template(rental, template) {
      const vm = this;
      template.content = $("#redactor-uuid-1").html();
      // TODO create service for updating template
      Vue.$http
        .put(`/templates/${template.id}`, template)
        .then((response) => {
          if (response && response.status === 200) {
            vm.getTemplates();
            toastr.success(response.data.msg);
            vm.loading = false;
            $("#redact").html("");
            $("#modal-close").click();
          }
        })
        .catch((error) => {
          if (error.response) {
            if (
              error.response &&
              error.response.data &&
              error.response.data.msg &&
              typeof error.response.data.msg === "object"
            ) {
              for (const key in error.response.data.msg) {
                if (error.response.data.msg.hasOwnProperty(key)) {
                  toastr.error(error.response.data.msg[key]);
                }
              }
            } else {
              toastr.error(error.response.data.msg);
            }
            vm.loading = false;
          }
        });
    },
    close_modal() {
      const vm = this;
      vm.customTemplate = {};
      $("#redact").html("");
    },
    connectStripe(rental_id) {
      if (this.stripe_name != "") {
        localStorage.setItem("rental_id", rental_id);
        localStorage.setItem("stripe_name", this.stripe_name);
        localStorage.setItem("stripe_account_type", "rental");
        location.href = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${this.stripeClientId}&scope=read_write`;
      } else {
        return false;
      }
    },
    getStripeAccounts() {
      stripeAccountsService.get(this);
    },
    openCheckListModal() {
      this.newChecklistGroup = {
        title: "",
        description: "",
        checklist_group_type_id: 4,
        checklists: [],
        images: [],
      };
      this.checklists = [];
      this.checlistItem = "";
      this.openModal("#checklists-modal");
      checklistGroupTypeService.get(this);
    },
    closeChecklistModal(selector) {
      const vm = this;
      vm.closeModal(selector);
      vm.selectedChecklistId = "";
    },
    addNewChecklist(checlistItem, event) {
      const vm = this;
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (checlistItem.trim() !== "") {
        vm.checklists.push({ name: checlistItem });
        vm.checlistItem = "";
      } else {
        return toastr.error(vm.$t("rentals.detail.checklists.name_required"));
      }
    },
    saveChecklistGroup(newChecklistGroup, rental_id) {
      const vm = this;
      newChecklistGroup.checklists = vm.checklists;
      newChecklistGroup.images = vm.checklistGroupImages;
      newChecklistGroup.rental_id = rental_id;

      checklistGroupService.store(this, newChecklistGroup);
    },
    onChecklistImageChange(e) {
      const vm = this;
      vm.loadingImage = true;

      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }

      const formData = new FormData();
      formData.append("image", files[0]);
      formData.append("folder", "checklist-group");

      fileService
        .uploadImage(this, formData)
        .then((response) => {
          if (response && response.status === 200) {
            vm.checklistGroupImages.push(response.data);
            $("#checklists-modal .dropify-clear").click();
            vm.loadingImage = false;
          }
        })
        .catch((error) => {
          vm.loadingImage = false;
          $("#checklists-modal .dropify-clear").click();
          vm.showToasterError(error);
        });
    },
    openEditChecklistGroupModal(checklistGroup) {
      const vm = this;
      vm.selectedChecklistId = checklistGroup.id;
      this.checlistItem = "";
      checklistGroupTypeService.get(this);
      vm.openModal("#checklists-modal");
      vm.newChecklistGroup = checklistGroup;
      vm.newChecklistGroup.checklistGroupImages = checklistGroup.images;

      vm.checklists = JSON.parse(JSON.stringify(checklistGroup.checklists));
    },
    openDuplicateChecklistGroupModal(checklistGroup) {
      const vm = this;
      vm.selectedChecklistId = checklistGroup.id;
      checklistGroupTypeService.get(vm);
      vm.openModal("#duplicate-checklist-modal");
      vm.newChecklistGroup = checklistGroup;
      vm.newChecklistGroup.checklistGroupImages = checklistGroup.images;

      vm.checklists = checklistGroup.checklists;
    },
    updateChecklistGroup(newChecklistGroup, rental_id) {
      const vm = this;
      newChecklistGroup.checklists = vm.checklists;
      newChecklistGroup.images = vm.checklistGroupImages;
      if (newChecklistGroup.images.length == 0) {
        newChecklistGroup.images = vm.newChecklistGroup.checklistGroupImages;
      }
      newChecklistGroup.rental_id = rental_id;

      checklistGroupService.update(this, newChecklistGroup);
    },
    removeFromChecklist(index) {
      this.checklists.splice(index, 1);
    },
    openFormModal() {
      this.editFormModal = false;
      this.form = {
        title: "",
        description: "",
        redirect_url: "",
      };
      if (this.formTypes && this.formTypes[0]) {
        this.formItem.type = this.formTypes[0];
      }
      this.openModal("#form-modal");
    },
    closeFormsModal(selector) {
      const vm = this;
      vm.clearFormModalData();
      vm.selectedFormId = "";
      vm.fieldIsEditing = false;
      $("#form-modal .dropify-wrapper").removeClass("has-error");
      $("#form-modal .dropify-clear").click();
      vm.closeModal(selector);
    },
    onFormImageChange(e) {
      const vm = this;
      vm.loadingImage = true;

      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }

      const formData = new FormData();
      formData.append("image", files[0]);
      formData.append("folder", "forms");

      fileService
        .uploadImage(this, formData)
        .then((response) => {
          if (response && response.status === 200) {
            vm.formImage = response.data;
            $("#forms-modal .dropify-clear").click();
            vm.loadingImage = false;
            vm.formImageUploaded = true;
          }
        })
        .catch((error) => {
          $("#forms-modal .dropify-clear").click();
          vm.loadingImage = false;
          vm.showToasterError(error);
        });
    },
    onFormTypeSelectChange() {
      const vm = this;
      const type = vm.formsFields.type;
      vm.newFormSelect = [];
      vm.formsFieldsInputTypes = vm.formsFields.type.elements;

      if (type.id == "1") {
        vm.typeIsInput = true;
        vm.formsFields.select_options = [];
      } else {
        vm.typeIsInput = false;
      }

      if (type.id == "2") {
        vm.typeIsSelect = true;
      } else {
        vm.typeIsSelect = false;
      }

      if (type.id == "3") {
        vm.typeIsTextarea = true;
        vm.formsFields.select_options = [];
      } else {
        vm.typeIsTextarea = false;
      }
    },
    onFormInputTypeChange() {
      const vm = this;
      vm.formsFields.select_options = [];
    },
    addNewFormItem() {
      const vm = this;
      vm.fieldIsEditing = false;

      if (vm.formsFields.label.trim() === "") {
        return toastr.error(vm.$t("rentals.detail.forms.name_required"));
      }

      $.each(vm.formsFields, (key, value) => {
        if (value == "") {
          if (
            (key != "select_options" &&
              key != "element" &&
              key != "reference") ||
            (vm.formsFields.element && vm.formsFields.element.length === 0)
          ) {
            vm.formItemIsEmpty = true;
          }
        } else {
          vm.formItemIsEmpty = false;
        }
        if (key === "type") {
          if (vm.formsFields && vm.formsFields.type) {
            const element = vm.formsFields.type.elements.find(
              (elem) =>
                vm.formsFields.element && elem.id === vm.formsFields.element.id
            );
            if (!element) {
              vm.formsFields.element = null;
            }
          }
        }
      });

      if (
        vm.formsFields.type &&
        (vm.formsFields.element === null || vm.formsFields.element.length === 0)
      ) {
        vm.fieldIsEditing = true;

        return toastr.error(
          vm.$t("rentals.detail.forms.form_field_type_required")
        );
      }

      const referenceIndex = vm.formsFieldsReferences.indexOf(
        vm.formsFields.reference
      );

      vm.formsFieldsReferences.splice(referenceIndex, 1);

      if (vm.formItemIsEmpty === false) {
        vm.formItems.push(vm.formsFields);
        vm.formsFields = {
          id: "",
          element_id: "",
          element: [],
          label: "",
          type: "",
          mandatory: "",
          reference: "",
          select_options: [],
        };
        vm.typeIsSelect = false;
        vm.typeIsInput = false;
        vm.typeIsTextarea = false;
      }
    },
    addSelectOption(name) {
      const vm = this;
      if (name) {
        vm.formsFields.select_options.push({ name });
        vm.selectOptionName = "";
      } else {
        return false;
      }
    },
    removeOption(index) {
      const vm = this;
      vm.formsFields.select_options.splice(index, 1);
    },
    deleteOption(index, id) {
      const vm = this;

      formService.deleteOption(vm, id);

      vm.removeOption(index);
    },
    async getFormTypes() {
      const vm = this;
      await formService.getTypes(vm);
    },
    async getFormFieldTypes() {
      const vm = this;
      await formService.getFieldTypes(vm);
    },
    async getFormFieldReferences() {
      const vm = this;
      await formService.getFormFieldReferences(vm);
    },
    removeItemFromFormItems(index) {
      const vm = this;
      if (vm.formItems[index].reference) {
        vm.formsFieldsReferences.push(vm.formItems[index].reference);
      }
      vm.formItems.splice(index, 1);
      vm.loadingInModal = false;
      vm.removeReferences();
    },
    async deleteItemFromForm(id, index) {
      const vm = this;
      vm.loadingInModal = true;
      await formService.deleteField(vm, id);
      vm.removeItemFromFormItems(index);
    },
    async storeForm(rental_id) {
      const vm = this;
      if (vm.fieldIsEditing) {
        toastr.error(vm.$t("rentals.detail.forms.save_current_field"));
      } else {
        vm.fieldIsEditing = false;
        vm.loadingInModal = true;
        vm.formItem.items = vm.formItems;
        vm.formItem.image = vm.formImage;
        vm.formItem.rental_id = rental_id;
        vm.formCheckType.type = vm.formItem.type;
        vm.formCheckType.rental_id = vm.formItem.rental_id;
        await formService.checkFormType(vm, vm.formCheckType);
      }
    },
    async editForm(rental_id) {
      if (this.fieldIsEditing) {
        toastr.error(this.$t("rentals.detail.forms.save_current_field"));
      } else {
        this.fieldIsEditing = false;
        this.loadingInModal = true;
        this.formItem.items = this.formItems;
        this.formItem.image = this.formImage;
        this.formItem.rental_id = rental_id;
        this.formItem.formSteps = this.formSteps;
        await formService.update(this, this.formItem, rental_id);
        await this.removeReferences();

        this.loadingInModal = false;
      }
    },
    openEditFormModal(form) {
      this.formItem = {};
      this.editFormModal = true;
      this.formItem = form;
      this.formImage.path = form.image;
      this.formImageUploaded = true;
      this.formItems = form.fields;
      this.form = form;
      this.removeReferences();

      this.openModal("#form-modal");
    },
    clearFormModalData() {
      const vm = this;
      vm.formItems = [];
      vm.formsFields = {
        id: "",
        element_id: "",
        element: [],
        label: "",
        type: "",
        mandatory: "",
        reference: "",
        select_options: [],
      };
      vm.formImage = {};
      vm.formItem = {
        title: "",
        description: "",
        redirect_url: "",
        type: "",
      };
      vm.formsFieldsInputTypes = [];
      vm.newFormSelect = [];
      formService.get(vm, vm.$route.params.id);
    },
    editItemFromFormItems(index) {
      const vm = this;
      if (!vm.fieldIsEditing) {
        vm.fieldIsEditing = true;
        vm.formsFields.label = vm.formItems[index].label;
        vm.formsFields.mandatory = vm.formItems[index].mandatory;
        vm.formsFields.type = vm.formItems[index].type;
        vm.formsFields.id = vm.formItems[index].id;
        vm.formsFields.element_id = vm.formItems[index].element_id;
        vm.formsFields.reference = vm.formItems[index].reference;

        if (!vm.formItems[index].id) {
          vm.formsFields.element = vm.formItems[index].element;
        } else if (vm.formItems[index].type.name == "input") {
          vm.formsFields.element = vm.formItems[index].element;
        } else if (vm.formItems[index].type.name == "select") {
          vm.formsFields.element = vm.formItems[index].element;
        } else if (vm.formItems[index].type.name == "textarea") {
          vm.formsFields.element = vm.formItems[index].element;
        }

        if (vm.formItems[index].type.name == "input") {
          vm.typeIsInput = true;
          vm.typeIsSelect = false;
          vm.typeIsTextarea = false;
          vm.formsFieldsInputTypes = vm.formsFields.type.elements;

          if (
            vm.formsFields.element.name == "radio" ||
            vm.formsFields.element.name == "checkbox"
          ) {
            vm.formsFields.select_options = vm.formItems[index].select_options;
          } else {
            vm.formsFields.select_options = [];
          }
        } else if (vm.formItems[index].type.name == "select") {
          vm.typeIsSelect = true;
          vm.typeIsInput = false;
          vm.typeIsTextarea = false;

          vm.formsFields.select_options = vm.formItems[index].select_options;
        } else if (vm.formItems[index].type.name == "textarea") {
          vm.formsFieldsInputTypes = vm.formsFields.type.elements;
          vm.typeIsTextarea = true;
          vm.typeIsSelect = false;
          vm.typeIsInput = false;
        }

        vm.removeItemFromFormItems(index);
      } else {
        toastr.error(vm.$t("rentals.detail.forms.save_current_field"));
      }
    },
    async getAllForms(rentalId) {
      const vm = this;
      console.log("getAllForms rental id", rentalId);
      await formService.get(vm, rentalId);
    },
    async getChecklistGroup(rentalId) {
      const vm = this;
      console.log("getChecklistGroup rental id", rentalId);
      await checklistGroupService.get(vm, rentalId);
    },
    async deleteFormOrChecklist(item, type) {
      const vm = this;
      swal(
        {
          title: "Are you sure?",
          text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4" stroke="#fe763a"/></svg></div></div><div>You will not be able to recover this </div>',
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: "Yes, delete it!",
          closeOnConfirm: false,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();

          if (type == "form") {
            formService.deleteForm(vm, item);
          } else if (type == "checklist") {
            checklistGroupService.destroy(vm, item);
          }
        }
      );
    },
    duplicateFormOrChecklist(checklistGroup) {
      this.smallLoading = true;
      checklistGroupService.duplicate(this, checklistGroup);
    },
    removeReferences() {
      const vm = this;

      const fields = vm.formItems;
      const references = [];
      for (const obj in fields) {
        // skip loop if the property is from prototype
        if (!fields.hasOwnProperty(obj)) continue;
        if (fields[obj].reference) {
          references.push(fields[obj].reference);
        }
      }
      vm.formsFieldsReferences = vm.removeDuplicates(
        vm.formsFieldsReferences,
        references
      );
    },
    removeDuplicates(arr1, arr2) {
      for (var obj in arr2) {
        // skip loop if the property is from prototype
        if (!arr2.hasOwnProperty(obj)) continue;

        if (arr2[obj] != null) {
          const index = arr1.findIndex((x) => x.name == arr2[obj].name);
          if (index != -1) {
            arr1.splice(index, 1);
          }
        }
      }
      return arr1;
    },
    orderUp(index) {
      const vm = this;
      if (index == 0) {
        return false;
      }
      const item = vm.formItems[index];
      vm.formItems.splice(index, 1);
      vm.formItems.splice(index - 1, 0, item);
    },
    orderDown(index) {
      const vm = this;
      const length = vm.formItems.length;
      if (index == length) {
        return false;
      }
      const item = vm.formItems[index];
      vm.formItems.splice(index, 1);
      vm.formItems.splice(index + 1, 0, item);
    },
    getModuleOfDevice() {
      const vm = this;
      vm.netatmoModules = {};
      for (const obj in vm.netatmoDevices) {
        // skip loop if the property is from prototype
        if (!vm.netatmoDevices.hasOwnProperty(obj)) continue;

        if (vm.netatmoDevices[obj].id == vm.rental.netatmo_device_id) {
          vm.netatmoModules = vm.netatmoDevices[obj].netatmo_modules;
        }
      }
    },
    setNotatmoOrKey() {
      Vue.router.push({
        name: "account.settings.tab",
        params: { tab: "services" },
      });
    },
    setAirbnb() {
      Vue.router.push({
        name: "account.settings.tab",
        params: { tab: "platforms" },
      });
    },
    onChangeLockType(lock, e) {
      const vm = this;
      const index = vm.rental.the_keys_locks.findIndex((x) => x.id === lock.id);
      if (index === -1) {
        toastr.error("Something went wrong");
        vm.refresh();
      } else {
        vm.rental.the_keys_locks[index].type = lock.type;
      }
    },
    onLockDetailsChange(type, lock) {
      const vm = this;
      const index = vm.serviceData.the_keys_locks.findIndex(
        (x) => x.id === lock.id
      );
      if (index === -1) {
        return false;
      }
      if (type == "accessory") {
        vm.serviceData.the_keys_locks[index].accessory_code =
          lock.accessory_code;
      } else if (type == "arrival") {
        vm.serviceData.the_keys_locks[
          index
        ].arrival_time = `${lock.timeIn.HH}:${lock.timeIn.mm}`;
      } else if (type == "departure") {
        vm.serviceData.the_keys_locks[
          index
        ].departure_time = `${lock.timeOut.HH}:${lock.timeOut.mm}`;
      }
    },
    onLockConnect(id, field, e) {
      if (e) {
        this.serviceData.the_keys_locks.find((key) => key.id === id).connected =
          e.target.checked;
      } else {
        this.serviceData.the_keys_locks.find((key) => key.id === id)[
          Object.keys(field)[0]
        ] = Object.values(field)[0];
      }
    },

    stopWriting(event) {
      if (
        event.key != "ArrowUp" &&
        event.key != "ArrowDown" &&
        event.key != "ArrowLeft" &&
        event.key != "ArrowRight"
      ) {
        event.preventDefault();
      }
    },

    getAirbnbListings() {
      this.airbnbListingsLoading = true;
      rentalService.getAirbnbListings(this, this.$route.params.id);
    },

    async deleteChecklistImage(id, index) {
      const vm = this;
      await checklistGroupService.deleteImage(vm, id, index);
    },

    removeChecklistImage(index) {
      const vm = this;
      vm.checklistGroupImages.splice(index, 1);
    },

    orderChecklistItem(way, index) {
      const start = way === "up" ? index - 1 : index + 1;
      const item = this.checklists[index];
      const checklistData = JSON.parse(JSON.stringify(this.checklists));
      this.checklists[start].name = item.name;
      item.name = checklistData[start].name;
    },

    deleteFormImage(id) {
      const vm = this;
      vm.formImageUploaded = false;
      formService.deleteFormImage(vm, id);
    },

    async openRentalEmailModal() {
      const vm = this;
      vm.forwardEmail = vm.account.email;
      vm.rental.booking_hotel_id = this.rentalBookingComConfigs.hotelId;
      vm.rental.booking_room_id = this.rentalBookingComConfigs.roomCode;
      vm.rental.booking_rate_id = this.rentalBookingComConfigs.rateCode;
      if (
        !this.hasAccessToPlanIdFour(
          vm.rental.userPlanId && vm.rental.userPlanId
        )
      ) {
        vm.roomCodes = [];
        vm.rateCodes = [];
        if (vm.rental.booking_room_id) {
          vm.roomCodes.push({ code: vm.rental.booking_room_id });
        }
        if (vm.rental.booking_rate_id) {
          vm.rateCodes.push({ code: vm.rental.booking_rate_id });
        }
      } else if (!vm.rental.booking_hotel_id) {
        vm.roomCodes = [];
        vm.rateCodes = [];
      }
      if (
        vm.rental.booking_email &&
        vm.rental.booking_email != null &&
        vm.rental.forward_email &&
        vm.rental.forward_email != null
      ) {
        vm.openModal("#rental-email-modal");
      } else {
        await rentalService.generateEmail(vm, vm.$route.params.id);
      }
      this.$forceUpdate();
    },

    async updateForward(confirmed = false) {
      const data = {
        forward_email: this.rental.forward_email,
        roomId: this.rental.booking_room_id,
        hotelId: this.rental.booking_hotel_id,
        rateId: this.rental.booking_rate_id,
        allRates: this.rental.booking_all_rates_restrictions ? 1 : 0,
        confirmed,
      };
      this.smallLoading = true;
      await rentalService.updateForward(this, data, this.$route.params.id);
      mixpanel.track("web.rentals.sync.bookingcom");
    },

    async deconnectBooking(confirmed = false) {
      const data = {
        roomId: this.rental.booking_room_id,
        hotelId: this.rental.booking_hotel_id,
        confirmed,
      };
      this.smallLoading = true;
      await rentalService.deconnectBooking(this, data, this.$route.params.id);
    },

    async getRentalEvents(id) {
      const vm = this;
      await rentalService.getRentalEvents(vm, id);
    },

    showChecklistModal(bookingEvent) {
      const vm = this;
      vm.selectedBookingEvent = bookingEvent;
      vm.openModal("#checklist-modal");
    },
    showImageModal(src) {
      const vm = this;
      vm.openModal("#show-image-modal");
      $("#modal-image").attr("src", src);
    },
    closeImageModal() {
      $("#show-image-modal").removeClass("show");
      $.each($(".modal-backdrop"), (index, value) => {
        if (index != 0) {
          $(value).remove();
        }
      });
    },
    openExpediaModal() {
      const vm = this;
      vm.openModal("#rental-expedia-modal");
    },
    openConfigureOtherPlatformModal() {
      this.openModal("#rental-configure-other-platform-modal");
    },
    updateEditableModal(e, name, link, id, icalRestrictionId, icalOverride) {
      e.stopImmediatePropagation();
      if (id) {
        this.selectedIcalId = id;
        this.link = link;
        this.name = name;
        this.icalRestrictionId = icalRestrictionId;
        this.icalOverride = Boolean(icalOverride);
      } else {
        this.selectedIcalId = false;
        this.link = "";
        this.name = "";
        this.icalRestrictionId = 1;
        this.icalOverride = false;
      }

      this.openEditableModal(
        "#rental-configure-other-platform-modal",
        name,
        link
      );
    },
    addOtherPlatforms() {
      const data = {
        link: this.link,
        rental_id: this.rental.id,
        name: this.name,
        icalId: this.selectedIcalId,
        ical_restriction_id: this.icalRestrictionId,
        override: Boolean(this.icalOverride),
      };
      this.smallLoading = true;
      rentalService.addIcal(this, data);
    },
    updateIcals() {
      const data = {
        link: this.link,
        rental_id: this.rental.id,
        name: this.name,
        icalId: false,
        ical_restriction_id: this.icalRestrictionId,
        override: Boolean(this.icalOverride),
      };
      this.smallLoading = true;
      rentalService.addIcal(this, data);
    },
    deleteIcal(id) {
      $(".cancel").removeClass("disabled");
      $(".confirm").removeClass("disabled");

      swal(
        {
          title: this.$t("scheduler.planing.are_you_sure"),
          text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div></div>',
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: this.$t("rentals.detail.modals.yes_delete_it"),
          closeOnConfirm: false,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();

          rentalService.deleteIcal(this, { icalId: id });
        }
      );
    },
    async updateRentalExpedia() {
      const vm = this;
      vm.expediaButtonDisabled = true;
      const data = {
        expedia_sends_cleaning: vm.rental.expedia_sends_cleaning,
        expedia_sends_city_taxes: vm.rental.expedia_sends_city_taxes,
        // 'expedia_sends_nights': vm.rental.expedia_sends_nights,
        rental_id: vm.rental.id,
        expedia_room_id: vm.rental.expedia_room_id,
        expedia_hotel_id: vm.rental.expedia_hotel_id,
        expedia_rate_id: vm.rental.expedia_rate_id,
      };
      await rentalService.updateRentalExpedia(vm, data);
      vm.expediaButtonDisabled = false;
      vm.closeModal("#rental-expedia-modal");
    },
    getSuperCheckinLocks(rental_id) {
      const vm = this;
      accountService.getSuperCheckinLocks(vm, rental_id);
    },
    getAccountLockTypes() {
      const vm = this;
      accountService.getAccountLockTypes(vm);
    },
    getLocksOfAccount(type) {
      this.serviceData.selectedLockType = type;
      if (type === "SuperCheckin") {
        this.isSuperCheckinSelected = true;
        this.isTheKeysSelected = false;
        this.isIgloohomeSelected = false;
        this.isNukiLockSelected = false;
        this.isIgloohomeV2Selected = false;
      } else if (type === "TheKeys") {
        this.isTheKeysSelected = true;
        this.isSuperCheckinSelected = false;
        this.isIgloohomeSelected = false;
        this.isNukiLockSelected = false;
        this.isIgloohomeV2Selected = false;
      } else if (type === "Igloohome") {
        this.isIgloohomeSelected = true;
        this.isTheKeysSelected = false;
        this.isSuperCheckinSelected = false;
        this.isNukiLockSelected = false;
        this.isIgloohomeV2Selected = false;
      } else if (type === "Nuki") {
        this.isIgloohomeSelected = false;
        this.isTheKeysSelected = false;
        this.isSuperCheckinSelected = false;
        this.isNukiLockSelected = true;
        this.isIgloohomeV2Selected = false;
      } else if (type === "IgloohomeV2") {
        this.isIgloohomeSelected = false;
        this.isTheKeysSelected = false;
        this.isSuperCheckinSelected = false;
        this.isNukiLockSelected = false;
        this.isIgloohomeV2Selected = true;
      } else {
        this.isIgloohomeSelected = false;
        this.isTheKeysSelected = false;
        this.isSuperCheckinSelected = false;
        this.isNukiLockSelected = false;
        this.isIgloohomeV2Selected = false;
      }
    },
    updateAllLocks(lock, type) {
      if (type === "supercheckin") {
        if (lock.connected) {
          this.serviceData.superCheckinLocks.push(lock);
        } else {
          const index = this.serviceData.superCheckinLocks.findIndex(
            (superCheckinLock) => superCheckinLock.id === lock.id
          );
          this.serviceData.superCheckinLocks.splice(index, 1);
        }
      } else if (type === "igloohome") {
        if (lock.connected) {
          this.serviceData.igloohomeLocks.push(lock);
        } else {
          const index = this.serviceData.igloohomeLocks.findIndex(
            (igloohomeLock) => igloohomeLock.id === lock.id
          );
          this.serviceData.igloohomeLocks.splice(index, 1);
        }
      } else if (type === "igloohomeV2") {
        if (lock.connected) {
          this.serviceData.igloohomeV2Locks.push(lock);
        } else {
          const index = this.serviceData.igloohomeV2Locks.findIndex(
            (igloohomeLock) => igloohomeLock.id === lock.id
          );
          this.serviceData.igloohomeV2Locks.splice(index, 1);
        }
      } else if (type === "nuki") {
        if (lock.connected) {
          this.serviceData.nukiLocks.push(lock);
        } else {
          const index = this.serviceData.nukiLocks.findIndex(
            (nukiLock) => nukiLock.id === lock.id
          );
          this.serviceData.nukiLocks.splice(index, 1);
        }
      } else if (type === "TheKeys") {
        if (lock.connected) {
          this.serviceData.the_keys_locks.push(lock);
        } else {
          const index = this.serviceData.the_keys_locks.findIndex(
            (theKeysLock) => theKeysLock.id === lock.id
          );
          this.serviceData.the_keys_locks.splice(index, 1);
        }
      }
    },
    onUploadFileChange(e) {
      this.loadingFile = true;

      const files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.loadingFile = false;
        return;
      }
      const formData = new FormData();
      formData.append("file", files[0]);
      formData.append("folder", "forms");
      fileService.uploadFile(this, formData);
    },
    updateSelectedDepositPlatforms(platformId) {
      if (this.selectedDepositPlatforms.includes(platformId.toString())) {
        this.selectedDepositPlatforms = this.selectedDepositPlatforms.filter(
          (platform) => platformId.toString() !== platform.toString()
        );
      } else {
        this.selectedDepositPlatforms.push(platformId.toString());
      }
    },
    async getPropertyCode() {
      const data = {
        rentalId: this.rental.id,
        hotelId: this.rental.booking_hotel_id,
      };
      this.smallLoading = true;
      await rentalService.getBookingComRoomsAndRatesCodes(this, data);
    },
    removeWithBookings() {
      $(".cancel").removeClass("disabled");
      $(".confirm").removeClass("disabled");

      swal(
        {
          title: this.$t("rentals.detail.modals.there_are_also_bookings"),
          text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>${this.$t(
            "rentals.detail.modals.can_not_recover_rental"
          )}</div>`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: this.$t("rentals.detail.modals.yes_delete_it"),
          closeOnConfirm: false,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();

          rentalService.removeWithBookings(this, this.rental.id);
        }
      );
    },
    removeRentalFromOurSide(errorMsg) {
      $(".cancel").removeClass("disabled");
      $(".confirm").removeClass("disabled");

      swal(
        {
          title: errorMsg.charAt(0).toUpperCase() + errorMsg.slice(1),
          text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>${this.$t(
            "rentals.detail.modals.error_from_beds24"
          )}</div>`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: this.$t("rentals.detail.modals.yes_delete_it"),
          closeOnConfirm: false,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();

          rentalService.destroy(this, this.rental.id, true);
        }
      );
    },
    changeMinMaxReservationOffset(type, value) {
      this.rental[`${type}_advanced_booking_offset`] = value;
    },
    changeMinMaxArrivalConfigs(type, value) {
      this.rental[`${type}_stay_arrival`] = value;
    },
    showConfirmationModal(fromDeconnect = false) {
      this.closeModal("#rental-email-modal");
      swal(
        {
          title: this.$t("rentals.detail.availabilities_configured"),
          text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>${this.$t(
            "rentals.detail.availabilities_configured_are_you_sure"
          )}</div>`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: this.$t("rentals.detail.yes_reset_it"),
          closeOnConfirm: true,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();

          if (fromDeconnect) this.deconnectBooking(true);
          else this.updateForward(true);
        }
      );
    },
    savePlatforms(confirmed = false) {
      this.loading = true;

      const dataAirbnb = {
        airbnb_max_nights: this.rental.airbnb_max_nights,
        airbnb_min_nights: this.rental.airbnb_min_nights,
        airbnb_preparation_time: this.rental.airbnb_preparation_time,
        airbnb_availability_range: this.rental.airbnb_availability_range,
        instant_booking_allowed_category:
          this.rental.instant_booking_allowed_category,
        rentalId: this.rental.id,
      };

      rentalService.updateRentalAirbnbData(this, dataAirbnb);
      if (confirmed) {
        this.hideDisabledWarning();
      }
      const listing = this.airbnbRentals.find(
        (el) =>
          el.id === this.rental.airbnb_rental_id &&
          el.airbnb_account_id === this.rental.airbnb_account_id
      );
      if (listing) {
        this.rental.airbnb_account_id = listing.airbnb_account_id;
        this.rental.airbnb_rental_id = listing.airbnb_rental_id;
      }
      const data = {
        rentalId: this.rental.id,
        airbnbRentalId: this.rental.airbnb_rental_id,
        airbnbAccountId: this.rental.airbnb_account_id,
        confirmed,
        priceMultiplier: this.priceMultiplier,
      };
      rentalService.editPlatforms(this, data);
    },
    removeAirbnbBookings() {
      swal(
        {
          title: this.$t("rentals.detail.modals.there_are_also_bookings"),
          text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div></div>',
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: this.$t("rentals.detail.modals.yes_delete"),
          closeOnConfirm: true,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();

          this.savePlatforms(true);
        }
      );
    },
    initRentalCutOffHours() {
      for (let i = 0; i < 24; i++) {
        for (let j = 0; j < this.minutes.length; j++) {
          if (i === 0) {
            continue;
          }
          i < 10
            ? this.cutOffHours.push(`0${i}:${this.minutes[j]}`)
            : this.cutOffHours.push(`${i}:${this.minutes[j]}`);
        }
        for (let j = 0; j < this.checkinMinutes.length; j++) {
          i < 10
            ? this.checkinHours.push(`0${i}:${this.checkinMinutes[j]}`)
            : this.checkinHours.push(`${i}:${this.checkinMinutes[j]}`);
        }
      }
    },
    initRentalCutOffMinutes() {
      for (let i = 15; i < 361; i += 15) {
        this.checkinCheckoutDurationMinutes.push(i);
      }
    },
    selectNetatmoDeviceId(e) {
      this.serviceData.selectedNetatmoDevice = e.target.value;
    },
    generateTheKeysData() {
      this.theKeys.forEach(
        ({
          id,
          connected,
          arrival_time,
          departure_time,
          accessory_code,
          type,
        }) => {
          if (connected) {
            this.serviceData.the_keys_locks.push({
              id,
              connected,
              arrival_time,
              departure_time,
              accessory_code,
              type,
            });
          }
        }
      );
    },
    hasAccessToPlanIdFour(userPlanId = null) {
      return (
        (this.user.plan_id === 4 && !this.user.is_team_member) ||
        (this.user.is_team_member && userPlanId && userPlanId === 4)
      );
    },
    getChannelName(id) {
      return this.channels.find((channel) => channel.id === id).name;
    },
    getIcalRestrictions() {
      rentalService.getIcalRestrictions(this);
    },
    openImportBookingsModal() {
      this.openModal("#import-bookings-from-file");
    },
    syncRentalRestrictions() {
      rentalService.syncRentalRestrictions(this.rental.id, this);
    },
    syncRentalReservations() {
      rentalService.syncRentalReservations(this.rental.id, this);
    },
    openVrboConfigurationModal() {
      this.openModal("#vrbo-configuration-modal");
    },
    updateRentalGapFillField(value) {
      this.rental.gap_fill = value;
    },
    updateRentalGapFillPercent(value) {
      this.rental.gap_fill_percent = value;
    },
    updateDynamicPrice(value) {
      this.rental.dynamic_price_enabled = value;
    },
    saveVrboConfigurationTabData() {
      this.$refs.vrboConfigurationTab.saveData();
    },
    saveWebsiteData() {
      this.$refs.website.saveData();
    },
    updateRentalDefaultInventoryField(value) {
      this.rental.default_inventory = value;
    },
    updateRentalMinDaysUntilCheckin(value) {
      this.rental.min_days_until_checkin = value;
    },
    updateRentalPriceReduction(value) {
      this.rental.price_reductions = value;
    },
    enablePriceLab(value) {
      this.serviceData.price_lab_enabled = !!value.target.checked;
      if (!value.target.checked) {
        this.serviceData.price_lab_email = "";
        this.serviceData.price_lab_api_key = "";
      }
    },
    changePriceLabEmail(value) {
      this.serviceData.price_lab_email = value.target.value;
    },
    changePriceLabApiKey(value) {
      this.serviceData.price_lab_api_key = value.target.value;
    },
    handleDependentRentalIds(rentalIds) {
      this.rental.dependencies = [];
      rentalIds.map((value, key) => {
        if (value === true) {
          this.rental.dependencies = [...this.rental.dependencies, key];
        }
      });
    },
    async desyncAirbnb() {
      await rentalService.desyncAirbnb(this, { rentalId: this.rental.id });
    },
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
    percentAmounts() {
      const percentAmount = ["0"];
      for (let i = 1; i <= 200; i++) {
        percentAmount.push(`+ ${i} %`);
      }

      for (let j = 1; j <= 100; j++) {
        percentAmount.push(`- ${j} %`);
      }
      return percentAmount;
    },
    currency() {
      return this.rental.currency
        ? this.rental.currency.symbol
        : this.user.currency.symbol;
    },
  },
  beforeDestroy() {
    if (this.clipboardBtnCopyFormLink) {
      this.clipboardBtnCopyFormLink.destroy();
    }

    if (this.icalLinkClipboard) {
      this.icalLinkClipboard.destroy();
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/rentals/detail/detail.js